const STATUS_MAP = {
  Pending: "pending",
  Submitted: "submitted",
  Approved: "approved",
  Verified: "verified",
  Rejected: "rejected",
  Filed: "filed",
};

export default function TdsStatusBadge({ status }) {
  const key = STATUS_MAP[status] || "pending";
  return <span className={`tds-badge tds-badge--${key}`}>{status}</span>;
}
